module.exports = "<app-customer-segment-list></app-customer-segment-list>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/customer-segments/customer-segments.component.html
// module id = ./src/app/modules/customer-segments/customer-segments.component.html
// module chunks = main